import React, { useEffect, useState } from 'react';
import { Col, InputNumber, Row, Slider, } from 'antd';
import styled from 'styled-components';
import { COLOR } from 'constants/colors';
import { PillButton, RoundedButton } from 'components/button';

interface TabProps {
    defaultActiveKey: string,
    items: any,
    onChange: Function,
}

const SliderCont = styled.div`
    .tabs {  
        display: flex;  
        gap: 10px;
    }
    
`;



const PillTab: React.FC<TabProps> = ({ defaultActiveKey, items, onChange }: TabProps) => {


    const [activeIndex, setActiveIndex] = useState<string>(defaultActiveKey);
    const checkActive = (index: number, className: string) => +activeIndex === index ? className : "";
    const handleClick = (index: number) => { setActiveIndex(`${index}`); onChange(items[index]?.value) }

    useEffect(() => {
        defaultActiveKey && setActiveIndex(defaultActiveKey);
    }, [defaultActiveKey])

    return <SliderCont>
        <div className="tabs">
            {
                items.map((element: any, index: number) => (
                    <PillButton
                        key={index}
                        className={`tab ${checkActive(index, "active")}`}
                        onClick={() => handleClick(index)}
                    >
                        {element.label}
                    </PillButton>
                ))
            }

        </div>
        <br />
    </SliderCont>

};

export default PillTab;